module.exports = __webpack_public_path__ + "img/Jasper - Thumbs up.8e24a7ef.png";